import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { getLabelMessage } from '@gef-ui/localization/messages';

import InfoCircleTooltip from 'components/atoms/GefMui/InfoCircleTooltip';

import SettingsSwitch from '../NotificationSending/SettingsSwitch';
import TypeWithSubtypesTooltip from './TypeWithSubtypesTooltip';

export const LeadsSettings = ({ leads }) => {
	const settingsHeader = (
		<Stack
			spacing={1}
			direction="row"
			sx={{
				alignItems: 'center',
			}}
		>
			<Typography variant="h5" color="text.primary">
				{getLabelMessage('settings:leadsSettings')}
			</Typography>
			<InfoCircleTooltip text={getLabelMessage('settings:leadsSettingsTooltip')} />
		</Stack>
	);

	return (
		<Paper sx={{ p: 3, borderRadius: 2 }}>
			<Stack>
				{settingsHeader}
				<SettingsSwitch description={getLabelMessage('settings:leads')} disabled value />
				<Grid container>
					{leads.map((lead) => (
						<Grid
							key={lead.id}
							sx={{
								alignItems: 'center',
							}}
							size={4}
						>
							<TypeWithSubtypesTooltip item={lead} type="leads" />
						</Grid>
					))}
				</Grid>
			</Stack>
		</Paper>
	);
};

LeadsSettings.propTypes = {
	leads: PropTypes.array,
};

export default LeadsSettings;
